//# sourceMappingURL=status.mjs.map
/// <reference types="./status.d.mts" />
import * as $organization from "../../../data_types/data/auth/organization.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $button from "../../../ds/ds/components/button.mjs";
import * as $callout from "../../../ds/ds/components/callout.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $modal from "../../../ds/ds/components/modal.mjs";
import * as $typography from "../../../ds/ds/components/typography.mjs";
import * as $utils from "../../../ds/ds/utils.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $org_effects from "../../admin/effects/organization.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, Error, toList } from "../../gleam.mjs";

/**
 * The organization currently selected in the navbar, if the list is loaded.
 * 
 * @ignore
 */
function use_selected_organization() {
  let store = $store.use_state();
  let $ = store.organization;
  let $1 = store.organizations;
  if ($ instanceof Some && $1 instanceof $remote.Loaded) {
    let org_id = $[0];
    let organizations = $1[0][1];
    let _pipe = organizations;
    let _pipe$1 = $list.find(
      _pipe,
      (organization) => { return organization.id === org_id; },
    );
    return $option.from_result(_pipe$1);
  } else {
    return new None();
  }
}

/**
 * Reactivating an organization is harmless, so it applies straight away.
 * Only the deactivation, which silently stops every notification email for
 * every member, asks for a confirmation first.
 * 
 * @ignore
 */
function use_toggle_click(organization, confirm) {
  let modal = $modal.use_modal();
  let dispatch = $store.use_effect_dispatch();
  let set_enabled = (enabled) => {
    dispatch($org_effects.update_enabled(organization.id, enabled));
    return undefined;
  };
  return ((_capture) => {
    return $redraw.use_callback(_capture, [organization, confirm]);
  })(
    (_) => {
      let $ = organization.enabled;
      if ($) {
        let _pipe = modal.open(
          (props) => { return confirm([props, organization.display_name]); },
        );
        $promise.map(
          _pipe,
          (_capture) => {
            return $result.map(_capture, (_) => { return set_enabled(false); });
          },
        );
        return undefined;
      } else {
        return set_enabled(true);
      }
    },
  );
}

function confirm_deactivation() {
  return $redraw.component_(
    "ConfirmOrganizationDeactivation",
    (_use0) => {
      let props = _use0[0];
      let organization = _use0[1];
      let on_cancel = $e.on_click(
        (_) => { return props.on_end(new Error(undefined)); },
      );
      let on_confirm = $e.on_click(
        (_) => { return props.on_end(new Ok(undefined)); },
      );
      return $modal.modal(
        toList([]),
        toList([
          $modal.body(
            toList([$utils.stop_propagation()]),
            toList([
              $modal.title(
                toList([]),
                toList([$h.text(("Deactivate " + organization) + "?")]),
              ),
              $modal.explanations(
                toList([]),
                toList([
                  $h.text(
                    ((("Every member stops receiving notification emails: proposal ready, " + "comment mentions, question and data source assignments, due ") + "date and expiration reminders. Emails skipped while deactivated ") + "are not sent afterwards. Invitations keep going out, and the ") + "product itself keeps working exactly as usual.",
                  ),
                ]),
              ),
              $modal.actions(
                toList([]),
                toList([
                  $button.primary(
                    toList([on_cancel]),
                    toList([$h.text("Cancel")]),
                  ),
                  $button.secondary(
                    toList([on_confirm]),
                    toList([$h.text("Deactivate")]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

function email_notifications() {
  return $redraw.compose(
    confirm_deactivation(),
    (confirm) => {
      return $redraw.component_(
        "OrganizationEmailNotifications",
        (_use0) => {
          let organization = _use0[0];
          let on_click = use_toggle_click(organization, confirm);
          let paragraph = (_capture) => {
            return $typography.text(
              $typography.sm,
              $typography.regular,
              _capture,
            );
          };
          let $ = organization.enabled;
          if ($) {
            return $callout.info(
              toList([]),
              toList([
                $callout.header(
                  toList([]),
                  toList([$h.text("Email notifications are active")]),
                ),
                $callout.content(
                  toList([]),
                  toList([
                    $l.column(
                      toList([$l.gap(12), $l.align("start")]),
                      toList([]),
                      toList([
                        paragraph(
                          ("Members receive every notification email: proposal ready, " + "comment mentions, question and data source assignments, ") + "due date and expiration reminders.",
                        ),
                        paragraph(
                          (("Deactivating stops all of them, for every member of this " + "organization. Nothing else changes: the product keeps ") + "working exactly as usual, and invitations are still sent so ") + "new members can always be onboarded.",
                        ),
                        $button.primary(
                          toList([$e.on_click(on_click)]),
                          toList([$h.text("Deactivate organization")]),
                        ),
                      ]),
                    ),
                  ]),
                ),
              ]),
            );
          } else {
            return $callout.warning(
              toList([]),
              toList([
                $callout.header(
                  toList([]),
                  toList([$h.text("Email notifications are deactivated")]),
                ),
                $callout.content(
                  toList([]),
                  toList([
                    $l.column(
                      toList([$l.gap(12), $l.align("start")]),
                      toList([]),
                      toList([
                        paragraph(
                          ("Members of this organization receive no notification email. " + "Invitations are still sent, and everything else in the ") + "product works as usual.",
                        ),
                        paragraph(
                          "Reactivating restores notifications immediately. Emails " + "skipped while deactivated are not sent afterwards.",
                        ),
                        $button.primary(
                          toList([$e.on_click(on_click)]),
                          toList([$h.text("Reactivate organization")]),
                        ),
                      ]),
                    ),
                  ]),
                ),
              ]),
            );
          }
        },
      );
    },
  );
}

export function view() {
  return $redraw.compose(
    email_notifications(),
    (email_notifications) => {
      return $redraw.component_(
        "Status",
        (_) => {
          return $l.column(
            toList([$l.gap(24), $l.align("start")]),
            toList([]),
            toList([
              $typography.h1($typography.md, "Status"),
              (() => {
                let $ = use_selected_organization();
                if ($ instanceof Some) {
                  let organization = $[0];
                  return email_notifications([organization]);
                } else {
                  return $typography.text(
                    $typography.sm,
                    $typography.regular,
                    "Select an organization to manage its status.",
                  );
                }
              })(),
            ]),
          );
        },
      );
    },
  );
}
